import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import RoleForm from "./RoleForm";
import { roleValidationForm } from "../../utils/validationSchemas";

const EditRole = (props: any) => {
  const { handleEdit, isLoading, data, Permissions } = props;
  const [selectedPermission, setSelectedPermission] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(roleValidationForm),
    defaultValues: async () => {
      return {
        role: data?.group_name,
      };
    },
  });

  useEffect(() => {
    setSelectedPermission(
      data?.custom_permissions ? [...data?.custom_permissions] : []
    );
  }, [data]);
  useEffect(() => {
    setValue("custom_permissions", selectedPermission);
  }, [selectedPermission]);

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <RoleForm
        selectedUserPermissions={selectedPermission}
        Permissions={Permissions}
        errors={errors}
        register={register}
        setSelectedPermission={setSelectedPermission}
      />
    </FormLayout>
  );
};

export default EditRole;
